type Props = {
  svgProps?: React.SVGProps<SVGSVGElement>
  iconColor?: string
}

export const SendMsgIcon = ({ iconColor, svgProps }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
      {...svgProps}
    >
      <path
        d="M12.6302 0.514282C12.6859 0.375001 12.6532 0.215919 12.5471 0.109846C12.4411 0.00377241 12.282 -0.0288803 12.1427 0.0268321L1.23238 4.39096L1.23129 4.3914L0.892716 4.52683C0.762085 4.57908 0.671693 4.70005 0.658612 4.84014C0.645531 4.98022 0.711961 5.11584 0.830659 5.19138L1.13787 5.38688L1.1393 5.38779L4.88535 7.77164L7.26919 11.5177L7.27034 11.5195L7.46561 11.8263C7.54114 11.945 7.67676 12.0115 7.81684 11.9984C7.95693 11.9853 8.0779 11.8949 8.13016 11.7643L12.6302 0.514282ZM11.2553 1.93202L5.63485 7.55245L5.47335 7.29867C5.44389 7.25237 5.40462 7.2131 5.35831 7.18363L5.10452 7.02212L10.7249 1.40172L11.6088 1.04816L11.2553 1.93202Z"
        fill={iconColor || '#fff'}
      />
    </svg>
  )
}
